import gsap from 'gsap';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';

const init = () => {
    if (!DEVICE_WIDTH.isDesktop) {
        const bgImages = Array.from(document.querySelectorAll('.js-p-offer__bg-image'));

        bgImages.forEach((image) => {
            gsap.fromTo(
                image,
                {
                    y: '-20%',
                },
                {
                    y: '20%',
                    ease: 'none',
                    scrollTrigger: {
                        trigger: image,
                        scrub: true,
                        start: 'top bottom',
                        end: 'bottom top',
                    },
                },
            );
        });
    }
};

const _module = { init };

export default _module;
